import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import defaultsDeep from 'lodash-es/defaultsDeep';
import { IdleExpiry } from './core/expiry/expiry';
import { IdleExpiryLocalStorageService } from './core/expiry/expiry-local-storage.service';
import { IDLE_OPTIONS, NIdle } from './idle.namespace';
import { IdleService } from './idle.service';

export function provideIdle(options?: Partial<NIdle.IModuleOptions>): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: IDLE_OPTIONS,
            useValue: defaultsDeep(options || {}, NIdle.defaultOptions)
        },
        {
            provide: IdleExpiry,
            useExisting: IdleExpiryLocalStorageService
        },
        provideAppInitializer(() => {
            inject(IdleService).appInitialize();
        })
    ]);
}
